export const rfi2SecondaryProcessingSectionMapper = {
  //Business Capabilities
  secondary_processing_capabilities:
    'dynamic_sections.business_capability.secondary_processing_capabilities',

  laundry_equipment_and_facilities:
    'dynamic_sections.business_capability.laundry_equipment_and_facilities',
  laundry_utilities_and_infrastructure:
    'dynamic_sections.business_capability.laundry_utilities_and_infrastructure',
  laundry_wet_process:
    'dynamic_sections.business_capability.laundry_wet_process',
  laundry_dry_process:
    'dynamic_sections.business_capability.laundry_dry_process',
  laundry_product_types:
    'dynamic_sections.business_capability.laundry_product_types',

  //Responsible Sourcing
  responsible_sourcing_sustainability_for_secondary_processing:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability_for_secondary_processing',

  //Other Information
  additional_factory_information:
    'dynamic_sections.other_information.additional_factory_information',
  key_factory_personnel:
    'dynamic_sections.other_information.key_factory_personnel',
  key_customer: 'dynamic_sections.other_information.key_customer',
  factory_automation_level:
    'dynamic_sections.other_information.factory_automation_level',
  employee_information:
    'dynamic_sections.other_information.employee_information',
  factory_ownership: 'dynamic_sections.other_information.factory_ownership',
  financial_information:
    'dynamic_sections.other_information.financial_information',
}
